import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import type {
  RequestQualificationCertificate,
  RequestQualificationCertificateDetail,
  RequestQualificationCertificatePayload,
} from 'types/request_qualification_certificate'
import { PaginationParameter } from '../common/pagination'
import { mergeURL } from './lib'

const resource = 'request_qualification_certificates'

export const requests = {
  getList: (
    params: {
      worker_name?: string
    } & PaginationParameter,
  ) => {
    return axiosForGigbaseBiz.get<
      DataResponse<Array<RequestQualificationCertificate>>
    >(resource, { params })
  },
  sendQualificationRequest: (
    params: RequestQualificationCertificatePayload,
  ) => {
    return axiosForGigbaseBiz.post<
      DataResponse<RequestQualificationCertificate>
    >(resource, {
      worker_qualification_id: params.worker_qualification_id,
      remarks: params.remarks,
    })
  },
  getItem: (id: number) => {
    return axiosForGigbaseBiz.get<
      DataResponse<RequestQualificationCertificateDetail>
    >(mergeURL(resource, id.toString()))
  },
}
